var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("database-management", {
    attrs: {
      headings: _vm.headings,
      entries: _vm.entries,
      loading: _vm.loading,
      sort: _vm.sort,
      "sort-dir": _vm.sortDir,
    },
    on: {
      showModal: (id) => {
        _vm.selectedEntryId = id
        _vm.showModal()
      },
      updateSort: (key) => {
        _vm.updateSort(key)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "heading",
        fn: function () {
          return [_vm._v("Contract Management")]
        },
        proxy: true,
      },
      {
        key: "list",
        fn: function () {
          return _vm._l(_vm.sortedEntries, function (contract) {
            return _c("contract-management-list-item", {
              key: contract.id,
              attrs: { contract: contract },
              on: {
                edit: (id) => {
                  _vm.selectedEntryId = id
                  _vm.showModal()
                },
              },
            })
          })
        },
        proxy: true,
      },
      {
        key: "modal",
        fn: function () {
          return [
            _c("contract-management-modal", {
              ref: "modal",
              attrs: {
                contract:
                  _vm.selectedEntryIndex !== -1
                    ? _vm.entries[_vm.selectedEntryIndex]
                    : _vm.defaultEntry,
                requirements: _vm.requirements,
              },
              on: {
                create: (contract) => {
                  _vm.add(contract)
                },
                update: (contract) => {
                  _vm.update(contract)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }